import {
  Button,
  Divider,
  Drawer,
  Popconfirm,
  Space,
  Table,
  TableProps,
  Typography,
  message,
} from 'antd'
import dayjs from 'dayjs'
import { memo, useCallback, useEffect, useRef, useState } from 'react'

import { deleteAgent, getAgent } from '~/services/agent'
import { IAgent } from '~/types/agent'

import ModalForm from './ModalForm'
import ModalPasswordForm from './ModalPasswordForm'
import { Container } from './style'

const Index = () => {
  const [loading, setLoading] = useState(false)
  const [dataSource, setDataSource] = useState<IAgent[]>([])
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [isModalOpen, setisModalOpen] = useState(false)
  const [drawerFormData, setDrawerFormData] = useState<Partial<IAgent>>({})

  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(10)

  const onPageChange = useCallback((cPage: number, cSize: number) => {
    setPage(cPage)
    setSize(cSize)
  }, [])

  const fetchData = useCallback(() => {
    setLoading(true)
    getAgent(page, size)
      .then((res) => {
        setDataSource(res.data?.content || [])
        setTotal(res.data.total || 0)
      })
      .catch((err) => {
        message.error(
          err?.reponse?.data || err?.message || '请求错误，请稍后再试',
        )
      })
      .finally(() => {
        setLoading(false)
      })
  }, [page, size])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const onSearch = useCallback(() => {
    fetchData()
  }, [fetchData])

  const columns = useRef<TableProps<IAgent>['columns']>([
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      fixed: 'left',
    },
    {
      title: '经销商名',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      fixed: 'left',
    },
    {
      title: '电话号码',
      dataIndex: 'phone',
      key: 'phone',
      width: 100,
    },
    {
      title: '推广码',
      dataIndex: 'shareCode',
      key: 'phone',
      width: 200,
    },
    {
      title: '更新时间',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (text) => dayjs(text).format('YYYY-MM-DD HH:mm:ss'),
      width: 180,
    },
    {
      title: '创建时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => dayjs(text).format('YYYY-MM-DD HH:mm:ss'),
      width: 180,
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        return (
          <Space>
            <Typography.Link
              onClick={() => {
                setDrawerFormData(record)
                setIsDrawerOpen(true)
              }}
            >
              编辑
            </Typography.Link>
            <Divider style={{ marginInline: 0 }} type="vertical" />
            <Typography.Link
              onClick={() => {
                setDrawerFormData(record)
                setisModalOpen(true)
              }}
            >
              更新密码
            </Typography.Link>
            <Divider style={{ marginInline: 0 }} type="vertical" />
            <Popconfirm
              title="提示"
              description="确认删除？"
              onConfirm={() => {
                deleteAgent(record.id)
                  .then(() => {
                    message.success('删除成功')
                    fetchData()
                  })
                  .catch((err) => {
                    message.error(err?.message || '删除失败，请稍后再试～')
                  })
              }}
              okText="删除"
              cancelText="取消"
            >
              <Typography.Link type="danger">删除</Typography.Link>
            </Popconfirm>
          </Space>
        )
      },
      fixed: 'right',
      width: 180,
      align: 'center',
    },
  ])

  const addData = useCallback(() => {
    setIsDrawerOpen(true)
  }, [])
  const closeDrawer = useCallback(() => {
    setDrawerFormData({})
    setIsDrawerOpen(false)
  }, [])

  return (
    <Container>
      <div className="top">
        <Button
          style={{ marginRight: 12 }}
          type="primary"
          loading={loading}
          onClick={onSearch}
        >
          查询
        </Button>
        <Button onClick={addData}>新增</Button>
      </div>
      <div className="table">
        <Table
          rowKey="id"
          loading={loading}
          columns={columns.current}
          dataSource={dataSource}
          scroll={{ x: 1500, y: 500 }}
          pagination={{
            total,
            pageSize: size,
            current: page,
            onChange: onPageChange,
          }}
        />
      </div>
      <div className="pagination"></div>
      <Drawer
        title={drawerFormData.id ? '编辑经销商' : '新增经销商'}
        open={isDrawerOpen}
        onClose={closeDrawer}
        width={450}
        destroyOnClose
      >
        <ModalForm data={drawerFormData} refreshTable={fetchData} />
      </Drawer>
      <Drawer
        title="更新密码"
        open={isModalOpen}
        onClose={() => setisModalOpen(false)}
        width={450}
        destroyOnClose
      >
        <ModalPasswordForm data={drawerFormData} />
      </Drawer>
    </Container>
  )
}

export default memo(Index)
